export class SurCaseProcEfficacyInfoModel {
  SurCaseProcEfficacyInfoid: number;
  SurCaseId: number;
  EfficacyProcedureCode: string;
  EfficacyDataName: string;
  EfficacyDataValue: string;
  Updatedby: string;
}
